import React from 'react';
import PropTypes from 'prop-types';
import ReduxQuerySync from 'redux-query-sync';
import { getDisplayName } from 'helpers/component';

export default function PageQueryEnhancer(options = {}) {
    const storeKey = options.store || 'store';
    delete options.store;

    return function PageQueryHOC(WrappedComponent) {
        class PageQuery extends React.Component {
            constructor(props, context) {
                super(props);
                this.store = context[storeKey];
            }

            componentDidMount() {
                options.replaceState = true;
                this.unsubscribe = ReduxQuerySync({
                    store: this.store,
                    history: this.store.getHistory(),
                    ...options
                });
            }

            componentWillUnmount() {
                this.unsubscribe();
            }

            render() {
                // Wraps the input component in a container, without mutating it. Good!
                return <WrappedComponent {...this.props} />;
            }
        }

        PageQuery.contextTypes = {
            [storeKey]: PropTypes.object
        };

        PageQuery.displayName = `PageQuery(${getDisplayName(WrappedComponent)})`;

        return PageQuery;
    };
}



// WEBPACK FOOTER //
// ./src/hoc/PageQuery.js